import axios from "axios";
import OrderResponse from "@/models/OrderResponse.model.js";

const API_URL = process.env.VUE_APP_API_URL;

class OrderService{

    async sendOrder(token, orderData){
        return axios({
            method: 'post',
            url: API_URL + 'ordine/InsertOrdine',
            data: orderData,
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{
                    return Object.assign(new OrderResponse(), data.data);
                }              
            }
        )
        .catch(error => {return error;});
    }

}

export default new OrderService();